// Using bitwise operator I can
// pass back multiple codes.
export enum RegistrationCodes {
  ok = 0,
  requireToken = 450,
  usernameAlreadyExist = 451,
  invalidUsername = 452,
  requireUsername = 460,
  requirePassword = 461,
  tokenNotValid = 450,
  invalidPassword = 453,
  invalidFirstName = 462,
  invalidLastName = 463,
  emailAddress = 464,
  userAndEmailAreTheSame = 472
}



// WEBPACK FOOTER //
// ./src/models/registrationCodes.ts